module.exports = __webpack_public_path__ + "img/can_ring_claimant_icon.5a99974d.svg";